import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

const defaultTheme = {
  sidebarColor: "#2c3e50",
  topbarColor: "rgba(0, 123, 255, 0.1)",
  iconColor: "rgba(0, 123, 255, 0.9)",
  textColor: "white",
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem("customTheme");
    return stored ? JSON.parse(stored) : defaultTheme;
  });

  useEffect(() => {
    localStorage.setItem("customTheme", JSON.stringify(theme));
  }, [theme]);

  const updateTheme = (newValues) => {
    setTheme((prev) => ({ ...prev, ...newValues }));
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
